import Grid from '@mui/material/Grid';
import config from '../../app/config';
import makeStyles from '@mui/styles/makeStyles';
import {useDispatch, useSelector} from 'react-redux';
import {docTypes} from '../../store/reducers/dicts';
import {FormControl, MenuItem, Select} from '@mui/material';
import {useTranslation} from 'react-i18next';
import AgyleButton from '../ui/buttons/agyleButton';
import React, {useCallback, useEffect} from "react";
import {patient as patientPreferences, savePref} from '../../store/reducers/preferences';
import _ from "lodash";
import AgyleDialog from '../modal/agyleDialog';

const useStyles = makeStyles((theme) => ({
    modalBody: {
        background: "grey",
      //  color: "black",
        width: "60%",
        left: "20%",
        position: "absolute",
        top: "30px",
        padding: "20px",
        height: "90%",
        overflow: "auto",
        fontSize: "13px",
        borderRadius: "6px"
    },
    displayImageContainer: {
        marginTop: 30,
        height: "50%",
        overflow: "auto"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#ebebeb"
    }
}));

function ImageDisplay(props) {
    const classes = useStyles();
    const docTypesDict = useSelector(docTypes);
    const { t, i18n } = useTranslation();


    const viewDisplay = [
        {
            name: "OS->OD",
            value: 1
        },
        {
            name: "OS->OD->OU",
            value: 2
        },
        {
            name: "OD->OS",
            value: 3
        },
        {
            name: "OD->OS->OU",
            value: 4
        },
        {
            name: "OU",
            value: 5
        },
        {
            name: "Open related",
            value: 6
        },
    ]

    const [displayImagePref, setDisplayImagePreferences] = React.useState({});
    const patientPreferencesObject = useSelector(patientPreferences);

    const [loaded, setLoaded] = React.useState(false)
    const dispatch = useDispatch();

    useEffect(() => {

        setDisplayImagePreferences((prefOld)=>{
            let pref = _.cloneDeep(patientPreferencesObject.studiesTypeViews);
            let newPref = {};

            docTypesDict.forEach((item) => {
                if(config.studiesType)
                    newPref[item.name] = config.studiesType[item.name]
                if(pref.hasOwnProperty(item.name))
                    newPref[item.name] = pref[item.name]
            });

            setLoaded(true);

            return newPref;
        });

    },[patientPreferencesObject])

    const handleSetNewPreferences = (type, value) => {
        setDisplayImagePreferences((pref) => {
            pref[type.toString()] = value;
            return {...pref}
        });
    };

    const handleSavePreferences = () => {
        let data = _.cloneDeep(patientPreferencesObject);
        data.studiesTypeViews = displayImagePref;

        dispatch(savePref(data));
    }

    const buttons = () => {
        return [<AgyleButton size="small" onClick={handleSavePreferences}>Save</AgyleButton>];
    }

    return (
        <AgyleDialog
            title={"Image Display"}
            open={true}
            onClose={props.onClose}
            width={"lg"}
            contentStyle={classes.dialogContentStyle}
            disableSave
            buttons={buttons()}
        >
            <div>
                {docTypesDict && loaded &&
                    docTypesDict.map((a) => {
                        return <Grid container key={a.name} alignItems={"center"} style={{width: 450}}>
                            <Grid item xs={6}>  {a.name} </Grid>
                            <Grid item xs={6}>
                                <FormControl sx={{width: "100%"}}>
                                    <Select
                                        //id="admission-basic-information-patient-type"
                                        displayEmpty
                                        //disabled={a.name === "OCT"}
                                        value={displayImagePref[a.name.toString()] || null}
                                        onChange={(event) => {
                                            handleSetNewPreferences(a.name, event.target.value);
                                        }}
                                    >

                                        <MenuItem value={null}>
                                            <em>Normal</em>
                                        </MenuItem>

                                        {viewDisplay && viewDisplay.map(r => {
                                            return (<MenuItem value={r.value} key={r.name}>{r.name}</MenuItem>)
                                        })
                                        }
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid>
                })
                }
            </div>
        </AgyleDialog>);
}

export default ImageDisplay;